import type { RecipeVariants } from '@vanilla-extract/recipes'
import { ThreadPriority } from '#lib/plain/types'
import { priorityIconStyles } from './priority-icon.css'

export const PriorityIcon = ({
  size = 'md',
  value,
}: {
  value: ThreadPriority
  size?: NonNullable<
    RecipeVariants<typeof priorityIconStyles.container>
  >['size']
}) => {
  if (value === ThreadPriority.Urgent) {
    return (
      <div className={priorityIconStyles.container({ size })}>
        <span className={priorityIconStyles.exclamation}>!</span>
      </div>
    )
  }

  // Determine how many bars to fill
  const filledBars =
    value === ThreadPriority.Low ? 1 : value === ThreadPriority.Normal ? 2 : 3
  return (
    <div
      className={priorityIconStyles.container({ size })}
      data-priority={value}
    >
      {[0, 1, 2].map(i => (
        <div
          key={i}
          className={
            i < filledBars
              ? `${priorityIconStyles.bar} ${priorityIconStyles.barFilled}`
              : priorityIconStyles.bar
          }
        />
      ))}
    </div>
  )
}
